import { Badge } from '@chakra-ui/react';

const STATUS = {
  signed: { label: 'Signed', color: 'green' },
  declined: { label: 'Declined', color: 'red' },
  bounced: { label: 'Bounced', color: 'red' },
  expired: { label: 'Link expired', color: 'red' },
  viewed: { label: 'Viewed', color: 'blue' },
  opened: { label: 'Opened link', color: 'orange' },
  delivered: { label: 'Delivered', color: 'teal' },
  sent: { label: 'Sent', color: 'gray' },
};

const parse = value => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * Where a sent estimate stands with the customer, as a badge for the
 * estimates list. Renders nothing for estimates never sent.
 */
const EstimateStatus = ({ estimate }) => {
  const sent = parse(estimate.estimateLastSentDate);
  const opened = parse(estimate.estimateAccessedDate);
  const viewed = parse(estimate.estimateViewedDate);
  const signed = estimate.estimateSigned
    ? parse(estimate.estimateSignedDate)
    : null;
  const declined = parse(estimate.estimateRejectedDate);
  const expires = parse(estimate.estimateSigningTokenExpires);
  if (!sent && !signed) return null;

  const status = estimate.estimateSigned
    ? 'signed'
    : declined
      ? 'declined'
      : estimate.estimateEmailStatus === 'failed'
        ? 'bounced'
        : expires && expires < new Date()
          ? 'expired'
          : viewed
            ? 'viewed'
            : opened
              ? 'opened'
              : estimate.estimateEmailStatus === 'delivered'
                ? 'delivered'
                : 'sent';

  return (
    <Badge colorScheme={STATUS[status].color} variant="subtle" fontSize="0.7em">
      {STATUS[status].label}
    </Badge>
  );
};

export default EstimateStatus;
